module.exports = __webpack_public_path__ + "img/house-heart-white.c22e23d8.png";